import Box from 'fe-design-base/atoms/Box';
import Icon from 'fe-design-base/atoms/Icon';
import Text from 'fe-design-base/atoms/Text';

import { ASSISTED_STATUSES } from 'features/timesheets/constants';

import { toI18n } from 'util/i18n';

interface AssistedClockOutIndicatorProps {
  status?: string;
  pastDue?: boolean;
}

const { INITIATED, PAST_DUE } = ASSISTED_STATUSES;

const AssistedClockOutIndicator = ({
  status,
  pastDue,
}: AssistedClockOutIndicatorProps) => (
  <Box flex row alignItemsStart gap="8px">
    {status === INITIATED && (
      <Box flex vcenter mt={2}>
        <Icon iconName="Sparkle" size="small" color="primary500" />
      </Box>
    )}

    {status === INITIATED && (
      <Box>
        <Text variant="captions">
          {toI18n(
            `timecard_modal_v3.issues.assisted_clock_out.${
              pastDue ? PAST_DUE : INITIATED
            }`
          )}
        </Text>
      </Box>
    )}
  </Box>
);

export default AssistedClockOutIndicator;
